const AboutSection = () => {
  return (
    <section className="flex w-full items-center justify-center bg-[#f7f8ff] py-16">
      <div className="relative z-10 mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center gap-8 px-6 lg:flex-row lg:gap-16 lg:px-10">
        {/* Left Content - Image */}
        <div className="flex w-full justify-center lg:w-1/2">
          <img
            src="/img/about-us/DSC01037-1.png"
            alt="YES.co.id Team"
            className="h-auto w-full max-w-[560px] rounded-lg object-cover"
            sizes="(max-width: 767px) 100vw, 560px"
          />
        </div>

        {/* Right Content - Text */}
        <div className="w-full max-w-[540px] lg:w-1/2">
          <div className="mb-10">
            <div className="text-2xl font-bold leading-tight lg:text-3xl">
              <span className="font-['Poppins'] text-[#475467]">Tentang </span>
              <span className="font-['Poppins'] text-[#d91f2e]">YES.co.id</span>
            </div>
          </div>

          <div className="font-['Poppins'] text-[15px] leading-relaxed">
            <p>
              <span className="font-bold text-[#d91f2e]">YES.co.id </span>
              <span className="font-bold text-[#475467]">
                adalah job portal dan lembaga pelatihan yang mempersiapkan
                tenaga kerja unggul Indonesia untuk bekerja di Jepang.
              </span>
            </p>

            <br />
            <br />

            <p className="font-normal text-[#475467]">
              YES didirikan untuk menjawab kebutuhan akan talenta Indonesia yang
              siap menghadapi tantangan karier global, khususnya di Jepang. Kami
              menyediakan akses langsung ke lowongan kerja di perusahaan Jepang,
              sekaligus pelatihan bahasa Jepang intensif untuk memastikan
              kandidat siap dari sisi bahasa. YES tidak hanya menghubungkan
              talenta dengan kesempatan bekerja di Jepang, tapi juga memberikan
              pendampingan menyeluruh mulai dari belajar bahasa, persiapan
              wawancara, hingga panduan proses persiapan keberangkatan ke
              Jepang.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection
